import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import WhatsAppButton from "./components/feature/WhatsAppButton";
import ScrollToTop from "./components/feature/ScrollToTop";
import CookieConsent from "./components/feature/CookieConsent";

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppRoutes />
      <WhatsAppButton />
      <ScrollToTop />
      <CookieConsent />
    </BrowserRouter>
  );
}

export default App;
